<script lang="ts" generics="TData">
    import {
        getCoreRowModel,
        getExpandedRowModel,
        getFilteredRowModel,
        type Row,
        type TableOptions,
    } from "@tanstack/table-core";
    import { createSvelteTable, FlexRender } from "./ui/data-table/index.js";
    import * as Table from "./ui/table/index.js";
    import type { HTMLAttributes } from "svelte/elements";

    let props: Omit<TableOptions<TData>, "getCoreRowModel"> & {
        rowProps?: (row: Row<TData>) => HTMLAttributes<HTMLTableRowElement>;
        bodyProps?: HTMLAttributes<HTMLTableSectionElement>;
    } = $props();

    const table = createSvelteTable({
        ...props,
        get data() {
            return props.data;
        },
        getCoreRowModel: getCoreRowModel(),
        getExpandedRowModel: getExpandedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
    });

    export function setGlobalFilter(x: string) {
        table.setGlobalFilter(x);
    }

    export function resetGlobalFilter() {
        table.resetGlobalFilter();
    }
</script>

<Table.Root>
    <Table.Header class="bg-background sticky top-0 z-10">
        {#each table.getHeaderGroups() as headerGroup (headerGroup.id)}
            <Table.Row>
                {#each headerGroup.headers as header (header.id)}
                    <Table.Head>
                        {#if !header.isPlaceholder}
                            <FlexRender content={header.column.columnDef.header} context={header.getContext()} />
                        {/if}
                    </Table.Head>
                {/each}
            </Table.Row>
        {/each}
    </Table.Header>
    <Table.Body {...props.bodyProps}>
        {#each table.getRowModel().rows as row (row.id)}
            {@const rowProps = props.rowProps?.(row) ?? {}}
            <Table.Row data-state={row.getIsSelected() && "selected"} {...rowProps}>
                {#each row.getVisibleCells() as cell (cell.id)}
                    <Table.Cell>
                        <FlexRender content={cell.column.columnDef.cell} context={cell.getContext()} />
                    </Table.Cell>
                {/each}
            </Table.Row>
        {:else}
            <Table.Row>
                <Table.Cell colspan={props.columns.length} class="h-24 text-center">No results.</Table.Cell>
            </Table.Row>
        {/each}
    </Table.Body>
</Table.Root>

<style lang="postcss">
    :global([data-slot="table-container"]) {
        @apply grow;
    }
</style>
